import _defineProperty from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "application"
};
var _hoisted_2 = {
  class: "application-top"
};
var _hoisted_3 = {
  class: "application-top-logo"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "overflow-auto"
};
var _hoisted_6 = ["onClick", "onMouseenter", "onMouseleave"];
var _hoisted_7 = {
  class: "application-top-tabs-img"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  key: 0,
  class: "application-top-tabs-num"
};
var _hoisted_11 = {
  key: 1,
  class: "application-top-tabs-num"
};
var _hoisted_12 = {
  key: 2,
  class: "application-top-tabs-num"
};
var _hoisted_13 = {
  key: 3,
  class: "application-top-tabs-num"
};
var _hoisted_14 = {
  key: 4,
  class: "application-top-tabs-num"
};
import { ref, onBeforeUnmount, watch, computed } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { useRoute, useRouter } from 'vue-router';
import { getStore } from '@/util/store';
import navLeft from '@/components/navLeft';
import WujieVue from 'wujie-vue3';
import resourcePreview from '@/views/sourcePreview/resourcePreview';
import FilePreviewDialog from 'hxhy-file-preview';
import { getAppAlias, getAppCategoryBubbleByCategories } from '@/api/home.js';
import { getAppUrl } from '@/const/router';
import { matchesAppMenuRoute } from '@/util/appMenuRoute';
import sendEvent from 'hxhy-send-track';
import lrz from 'lrz';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
var DEFAULT_TITLE = '慧学慧研';
export default {
  __name: 'Application',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var bus = WujieVue.bus;
    var routeQuery = ref(route.query); // 路由参数

    // 监听路由 query 变化，确保返回时高亮更新
    watch(function () {
      return route.query;
    }, function () {
      routeQuery.value = route.query;
    }, {
      immediate: false
    });
    var visible = ref(false);
    var visibleLeftBar = ref(true);
    var sourceData = ref(null);
    var leftNav = ref(null);
    var app = ref({});
    var previewWidth = ref('');
    var mouseenter = function mouseenter(item, e) {
      // 只有非 active 状态才在 hover 时切换为 active 图标
      if (!e.target.classList.contains('active')) {
        e.target.querySelector('div img').src = require("@/assets/nav/".concat(item.icon, "-active.svg"));
      }
    };
    var mouseleave = function mouseleave(item, e) {
      // 只有非 active 状态才在离开时切换回普通图标
      if (!e.target.classList.contains('active')) {
        e.target.querySelector('div img').src = require("@/assets/nav/".concat(item.icon, ".svg"));
      }
    };
    var access_token = getStore({
      name: 'access_token'
    }); // 传递token到子应用
    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 传递accessInfo到子应用
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取用户信息
    var appsInfo = getStore({
      name: 'platformApps'
    }) || []; // 获取所有应用列表
    // 路由 name 即子应用 projectName：优先按 appAlias 匹配，兜底按 projectName，避免两个字段不一致时取不到应用导致渲染崩溃
    app.value = appsInfo.find(function (item) {
      return item.appAlias === route.name;
    }) || appsInfo.find(function (item) {
      return item.projectName === route.name;
    });
    // 子应用入口地址，取不到应用信息时为空串，配合模板 v-if 不渲染 WujieVue
    var appUrl = computed(function () {
      return app.value ? getAppUrl(app.value) : '';
    });
    var navClick = function navClick(item, index) {
      visibleLeftBar.value = true;
      if (item.path && item.path !== route.query[route.name] && (route.query[route.name] !== undefined || index !== 0)) {
        router.push({
          path: route.path,
          query: _defineProperty({}, route.name, item.path)
        });
        bus.$emit('routeChange', item.path);
      }
    };
    var isActive = function isActive(item, index) {
      var _app$value;
      var currentQuery = route.query[route.name];
      // 同时兼容内部路径与 Wujie 刷新后带部署目录的同步路径。
      if (matchesAppMenuRoute(currentQuery, item.path, (_app$value = app.value) === null || _app$value === void 0 ? void 0 : _app$value.projectUrl)) {
        return true;
      }
      if (currentQuery === undefined && index === 0) {
        return true;
      }
      return false;
    };
    var overtime = window.overtime;
    var origin = window.location.origin;
    var queryObj = ref(null);
    if (route.query && route.query.hideLeftBar || location.search.includes('hideLeftBar')) {
      visibleLeftBar.value = false;
    }
    if (window.location.search) {
      var obj = {};
      new URLSearchParams(window.location.search).forEach(function (value, key) {
        obj[key] = value;
      });
      queryObj.value = obj;
    }
    var jump = function jump(location, query) {
      var currentWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      queryObj.value = query;
      if (location.indexOf('/courseDetail') > -1 || location.indexOf('/curriculumDetail') > -1 || location.indexOf('/newCurriculumDetail') > -1 || location.indexOf('/practiceDetail') > -1 || location.indexOf('/articleDetail') > -1 || location.indexOf('/resourceDetail') > -1 || location.indexOf('/newsDetail') > -1 || location.indexOf('activityDetail') > -1 || location.indexOf('researchTrain') > -1 || location.indexOf('editResource') > -1 || location.indexOf('/questionnaireSurvey') > -1) {
        var url = origin + location;
        currentWindow ? window.location.href = url : window.open(url);
      } else {
        router.push(location);
        if (query && query.path) {
          bus.$emit('routeChange', query.path);
        }
      }
    };
    var compressImgLrz = function compressImgLrz(arrbf, type) {
      return new Promise(function (resolve) {
        var file = new File([arrbf], '', {
          type: type,
          lastModified: Date.now()
        });
        lrz(file).then(function (res) {
          resolve(res.base64);
        }).catch(function (err) {
          console.log('压缩失败', err);
        });
      });
    };
    var openResourcePreview = function openResourcePreview(data) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1200px';
      sourceData.value = data;
      visible.value = true;
      previewWidth.value = width;
    };
    var newResourceVisible = ref(false); // 新素材预览弹窗
    var filePath = ref(''); // 新素材预览弹窗文件路径
    var sourceId = ref(''); // 新素材预览资源id
    var sourceName = ref(''); // 新素材预览资源名称
    var showDownload = ref(false); // 新素材预览弹窗下载按钮
    var fileType = ref(''); // 新素材预览弹窗文件类型
    var subjectId = ref(''); // 新素材预览弹窗学科id
    var subjectName = ref(''); // 新素材预览弹窗学科名称
    var token = ref(getStore({
      name: 'access_token'
    }));
    bus.$on('openNewResourcePreview', function (obj) {
      console.log(obj);
      openNewResourcePreview(obj);
    });
    var openNewResourcePreview = function openNewResourcePreview(obj) {
      filePath.value = obj.filePath || '';
      sourceId.value = !filePath.value ? obj.id : '';
      sourceName.value = obj.sourceName || '';
      showDownload.value = obj.showDownload || false;
      fileType.value = obj.fileType || '';
      subjectId.value = obj.subjectId || '';
      subjectName.value = obj.subjectName || '';
      newResourceVisible.value = true;
    };
    var closeFilePreviewDlg = function closeFilePreviewDlg() {
      bus.$emit('closeFilePreviewDlg');
    };
    var toggleLeftBar = function toggleLeftBar(tag) {
      visibleLeftBar.value = tag;
    };
    // 子应用菜单栏动态管理
    var isFresh = ref(false);
    var appMenus = ref();
    var appInfo = ref();
    // 获取app信息 渲染左侧头部图片
    var icon = ref('');
    var getAppInfoMtd = function getAppInfoMtd() {
      getAppAlias(route.name).then(function (res) {
        if (res.data.code === 0) {
          var _res$data$data, _res$data$data2;
          appInfo.value = res.data.data;
          icon.value = (_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.app.icon;
          appMenus.value = (_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2.menus;
        }
      }).finally(function () {
        isFresh.value = true;
      });
    };
    getAppInfoMtd();
    // 动态修改导航名称
    var findObj = appsInfo.find(function (item) {
      return route.name === item.alias;
    });
    if (findObj) {
      document.title = findObj.appName;
    } else {
      document.title = DEFAULT_TITLE;
    }
    var sendTrack = function sendTrack() {
      var _getStore$memberType;
      sendEvent([{
        eventCode: 'Platform_page_visit',
        eventTime: new Date().getTime(),
        userId: getStore({
          name: 'userInfo'
        }) ? getStore({
          name: 'userInfo'
        }).id : '',
        userName: getStore({
          name: 'userInfo'
        }) ? getStore({
          name: 'userInfo'
        }).name : '',
        identity: getStore({
          name: 'userInfo'
        }) ? (_getStore$memberType = getStore({
          name: 'userInfo'
        }).memberType) === null || _getStore$memberType === void 0 ? void 0 : _getStore$memberType.join() : '',
        customParam: JSON.stringify({
          currPage: route.name,
          pageUrl: encodeURIComponent(location.href)
        })
      }]);
    };
    sendTrack();
    var closeCurrentPage = function closeCurrentPage() {
      window.close();
    };
    var exportPDFByImg = function exportPDFByImg(image) {
      var otherInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Promise(function (resolve, reject) {
        try {
          var pdf = new jsPDF({
            orientation: 'landscape',
            unit: 'px',
            format: [otherInfo.width, otherInfo.height]
          });
          pdf.addImage(image, otherInfo.imgFormat || 'PNG', 0, 0, otherInfo.width, otherInfo.height);
          pdf.save(otherInfo.download || '画布.pdf');
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    };
    var createSocket = function createSocket(url, message) {
      if (url && url.startsWith('ws')) {
        try {
          if ('WebSocket' in window) {
            return new WebSocket(url);
          } else if ('MozWebSocket' in window) {
            /* eslint-disable-next-line no-undef */
            return new MozWebSocket(url);
          } else {
            MessagePlugin.error('浏览器不支持WebSocket');
            return null;
          }
        } catch (error) {
          MessagePlugin.error(message || '录音发送失败，请再试一次');
        }
      } else {
        return null;
      }
    };
    var exportPDF = function exportPDF(canvas) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var otherInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return new Promise(function (resolve) {
        html2canvas(canvas, options).then(function (img) {
          var pdf = new jsPDF({
            orientation: 'landscape',
            unit: 'px',
            format: [canvas.width, canvas.height]
          });
          pdf.addImage(img.toDataURL('image/png'), 'PNG', 0, 0, canvas.width, canvas.height);
          pdf.save(otherInfo.download || '画布.pdf');
          resolve(true);
        }).catch(function (err) {
          resolve(err);
        });
      });
    };
    var popBusinessList = ['applyApp', 'inspirationCentre', 'sourceManage', 'orgSourceManage'];
    var cateGoryByApp = {
      applyApp: [{
        appAlias: 'applyApp',
        category: 'examine'
      }],
      inspirationCentre: [{
        appAlias: 'inspirationCentre',
        category: 'repository '
      }, {
        appAlias: 'inspirationCentre',
        category: 'shares '
      }],
      sourceManage: [{
        appAlias: 'sourceManage',
        category: 'reviewStaging'
      }],
      orgSourceManage: [{
        appAlias: 'orgSourceManage',
        category: 'orgReviewStaging'
      }]
    };
    var popNum = ref(null); // 气泡数量
    var popRepository = ref(null);
    var popShares = ref(null);
    var popReviewStaging = ref(null);
    var popOrgReviewStaging = ref(null);
    var popData = ref(); //气泡数据
    var getPopNum = function getPopNum(dt1, dt2) {
      var data1 = dt1 || {
        flush: 1
      };
      var data2 = dt2 || cateGoryByApp[route.name]; //[{ appAlias: route.name, category: 'examine' }]
      getAppCategoryBubbleByCategories(data1, data2).then(function (res) {
        if (res.data.code === 0) {
          var _resData$find, _resData$find2, _resData$find3, _resData$find4, _resData$find5;
          var resData = res.data.data || [];
          var targetNum = (_resData$find = resData.find(function (i) {
            return i.category.appAlias === data2[0].appAlias;
          })) === null || _resData$find === void 0 ? void 0 : _resData$find.num;
          popNum.value = targetNum > 99 ? '99+' : targetNum;
          var repository = (_resData$find2 = resData.find(function (i) {
            return i.category.category === 'repository';
          })) === null || _resData$find2 === void 0 ? void 0 : _resData$find2.num;
          popRepository.value = repository > 99 ? '99+' : repository;
          var shares = (_resData$find3 = resData.find(function (i) {
            return i.category.category === 'shares';
          })) === null || _resData$find3 === void 0 ? void 0 : _resData$find3.num;
          popShares.value = shares > 99 ? '99+' : shares;
          var reviewStaging = (_resData$find4 = resData.find(function (i) {
            return i.category.category === 'reviewStaging';
          })) === null || _resData$find4 === void 0 ? void 0 : _resData$find4.num;
          popReviewStaging.value = reviewStaging > 99 ? '99+' : reviewStaging;
          var orgReviewStaging = (_resData$find5 = resData.find(function (i) {
            return i.category.category === 'orgReviewStaging';
          })) === null || _resData$find5 === void 0 ? void 0 : _resData$find5.num;
          popOrgReviewStaging.value = orgReviewStaging > 99 ? '99+' : orgReviewStaging;
        }
      });
    };
    if (popBusinessList.includes(route.name)) {
      getPopNum();
    }
    var backHome = function backHome() {
      var _leftNav$value;
      (_leftNav$value = leftNav.value) === null || _leftNav$value === void 0 || _leftNav$value.handleGoHome();
    };
    var reloadMainApp = function reloadMainApp() {
      window.location.reload();
    };

    // 刷新：bus 事件与 props.reloadMainApp 共用同一处理函数
    bus.$on('reload-main-app', reloadMainApp);
    watch(function () {
      return route.name;
    }, function (value) {
      var findObj = appsInfo.find(function (item) {
        return value === item.alias;
      });
      if (findObj) {
        document.title = findObj.appName;
      } else {
        document.title = DEFAULT_TITLE;
      }
    });
    onBeforeUnmount(function () {
      document.title = DEFAULT_TITLE;
      bus.$off('openNewResourcePreview');
      bus.$off('reload-main-app', reloadMainApp);
    });

    // 安卓拍照回调
    window['onPictureData_source'] = function (data) {
      try {
        console.log('main图片选择回调', data);
      } catch (error) {
        console.log('上传失败', error);
      }
    };
    return function (_ctx, _cache) {
      return isFresh.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_unref(navLeft), {
        ref_key: "leftNav",
        ref: leftNav,
        appInfo: appInfo.value
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: icon.value,
            alt: ""
          }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appMenus.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["application-top-tabs", {
                active: isActive(item, index)
              }]),
              key: "".concat(index, "-").concat(_unref(route).query[_unref(route).name]),
              onClick: function onClick($event) {
                return navClick(item, index);
              },
              onMouseenter: function onMouseenter(e) {
                return mouseenter(item, e);
              },
              onMouseleave: function onMouseleave(e) {
                return mouseleave(item, e);
              }
            }, [_createElementVNode("div", _hoisted_7, [isActive(item, index) ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.icon ? require("@/assets/nav/".concat(item.icon, "-active.svg")) : ''
            }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: item.icon ? require("@/assets/nav/".concat(item.icon, ".svg")) : ''
            }, null, 8, _hoisted_9))]), _createElementVNode("div", null, _toDisplayString(item.name), 1), popNum.value && item.path === '/permissionApproval' ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(popNum.value), 1)) : _createCommentVNode("", true), popRepository.value && item.path === '/repository' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(popRepository.value), 1)) : _createCommentVNode("", true), popShares.value && item.path === '/shares' ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(popShares.value), 1)) : _createCommentVNode("", true), popReviewStaging.value && item.path === '/reviewStaging' ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(popReviewStaging.value), 1)) : _createCommentVNode("", true), popOrgReviewStaging.value && item.path === '/orgReviewStaging' ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(popOrgReviewStaging.value), 1)) : _createCommentVNode("", true)], 42, _hoisted_6);
          }), 128))])])];
        }),
        _: 1
      }, 8, ["appInfo"]), [[_vShow, visibleLeftBar.value]]), appUrl.value ? (_openBlock(), _createBlock(_unref(WujieVue), {
        key: 0,
        style: {
          "flex": "1"
        },
        width: visibleLeftBar.value ? 'calc(100% - 64px)' : '100%',
        height: "100%",
        name: _ctx.$route.name,
        props: {
          access_token: _unref(access_token),
          accessInfo: _unref(accessInfo),
          userInfo: _unref(userInfo),
          overtime: _unref(overtime),
          jump: jump,
          compressImgLrz: compressImgLrz,
          toggleLeftBar: toggleLeftBar,
          openResourcePreview: openResourcePreview,
          openNewResourcePreview: openNewResourcePreview,
          query: queryObj.value,
          appInfo: appInfo.value,
          sendTrack: sendTrack,
          sendEvent: _unref(sendEvent),
          reloadMainApp: reloadMainApp,
          closeCurrentPage: closeCurrentPage,
          createSocket: createSocket,
          exportPDFByImg: exportPDFByImg,
          exportPDF: exportPDF,
          backHome: backHome,
          routeQuery: routeQuery.value,
          getPopNum: getPopNum
        },
        url: appUrl.value,
        sync: true
      }, null, 8, ["width", "name", "props", "url"])) : _createCommentVNode("", true), visible.value ? (_openBlock(), _createBlock(_unref(resourcePreview), {
        key: 1,
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        sourceData: sourceData.value,
        width: previewWidth.value
      }, null, 8, ["visible", "sourceData", "width"])) : _createCommentVNode("", true), newResourceVisible.value ? (_openBlock(), _createBlock(_unref(FilePreviewDialog), {
        key: 2,
        modelValue: newResourceVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return newResourceVisible.value = $event;
        }),
        path: filePath.value,
        "source-id": sourceId.value,
        "source-name": sourceName.value,
        token: token.value,
        showDownload: showDownload.value,
        "file-type": fileType.value,
        "subject-id": subjectId.value,
        "subject-name": subjectName.value,
        onClose: closeFilePreviewDlg
      }, null, 8, ["modelValue", "path", "source-id", "source-name", "token", "showDownload", "file-type", "subject-id", "subject-name"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }
};